"use client";

import React from "react";
import Icon, { Icons } from '../../Icon/Icon';

import { Variants, Sizes } from "../Button/Button";
import { cn } from "@/utils/cn";
import Link from "../../../NextJs/Link";

interface Props extends React.ComponentProps<typeof Link> {
    children: React.ReactNode;
    icon?: Icons;
    iconPosition?: "before"|"after";
    size?: keyof typeof Sizes;
    variant?: keyof typeof Variants;
    target?: "_blank" | "_self" | "_parent" | "_top";
    title?: string;
    className?: string;
    rel?: string;
}

/**
 * Wrapper for using next/link and our button styles
 */
const ButtonLink = ({ children, icon, iconPosition = "after", size = "default", variant = "primarySolid", href, title, target, className, ...props }: Props) => {
    return (
        <Link {...props} href={href} title={title} className={cn('button', Variants[variant], Sizes[size], className)} target={target}>
            {icon && iconPosition === 'before' && <Icon icon={icon} />}
            {children}
            {icon && iconPosition === 'after' && <Icon icon={icon} />}
        </Link>
    );
};

export default ButtonLink;
